import {
    CANCEL_CART_LOT_MODAL
  } from './constants';
  
  export function cancelCarLotModal() {
    return (dispatch) => {
      dispatch({
        type: CANCEL_CART_LOT_MODAL
      });
    }
  }
  
  export function reducer(state, action) {
    if  (action.type === CANCEL_CART_LOT_MODAL) {
        return {
          ...state,
          carLotConfirmPending: false,
        }
    }
    else {
        return state;
    }
  }